
document.addEventListener("DOMContentLoaded", function () {


	// search overlay
	const searchBtn = document.getElementById("searchBtn");
	const searchOverlay = document.getElementById("searchOverlay");
	const closeSearchOverlay = document.getElementById("closeSearchOverlay");

	searchBtn.addEventListener("click", function () {
		searchOverlay.classList.remove("opacity-0", "translate-y-full");
		searchOverlay.classList.add("opacity-100", "translate-y-0");
	});

	closeSearchOverlay.addEventListener("click", function () {
		searchOverlay.classList.remove("opacity-100", "translate-y-0");
		searchOverlay.classList.add("translate-y-full");
		setTimeout(function () {
			searchOverlay.classList.add("opacity-0");
		}, 500);
	});

	var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
	if (width >= 1024) {
		if (document.getElementById("specialGrid")) {
			var specialGridHeight =
				document.getElementById("specialGrid").offsetHeight;
			document.getElementById("specialScrollable").style.maxHeight =
				specialGridHeight + "px";
		}
	}
  
	// search overlay DESKTOP
	const searchBtn2 = document.getElementById("searchBtn2");
	const searchOverlay2 = document.getElementById("searchOverlay2");
	const closeSearchOverlay2 = document.getElementById("closeSearchOverlay2");

	searchBtn2.addEventListener("click", function () {
		searchOverlay2.classList.remove("opacity-0", "translate-y-full");
		searchOverlay2.classList.add("opacity-100", "translate-y-0");
	});

	closeSearchOverlay2.addEventListener("click", function () {
		searchOverlay2.classList.remove("opacity-100", "translate-y-0");
		searchOverlay2.classList.add("translate-y-full");
		setTimeout(function () {
			searchOverlay2.classList.add("opacity-0");
		}, 500);
	});

	var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
	if (width >= 1024) {
		if (document.getElementById("specialGrid")) {
			var specialGridHeight =
				document.getElementById("specialGrid").offsetHeight;
			document.getElementById("specialScrollable").style.maxHeight =
				specialGridHeight + "px";
		}
	}

  // hamburger menu
	const hamburgerBtn = document.getElementById("hamburgerBtn");
	const mobileMenu = document.getElementById("mobileMenu");
	const closeMenu = document.getElementById("closeMenu");

	hamburgerBtn.addEventListener("click", function () {
		mobileMenu.classList.remove("translate-x-full");
		mobileMenu.classList.add("translate-x-0");
	});

	closeMenu.addEventListener("click", function () {
		mobileMenu.classList.remove("translate-x-0");
		mobileMenu.classList.add("translate-x-full");
	});

	// mobile menu dropdown
	const dropdownToggle = document.querySelectorAll(".dropdown-toggle");
	for (let i = 0; i < dropdownToggle.length; i++) {
		const toggle = dropdownToggle[i];
		const svgIcon = toggle.nextElementSibling;
	
		svgIcon.addEventListener("click", function (event) {
			event.preventDefault();
			toggle.checked = !toggle.checked;
			document.querySelector(`.dropdown-${toggle.value}`).classList.toggle("hidden", !toggle.checked);
			svgIcon.querySelector("svg").classList.toggle("rotate-180", toggle.checked);
		});
	}


	//  SHORT LINK
	var shortLink = document.querySelector(".short-link-cnt");
	if (shortLink) {
		shortLink.addEventListener("click", function (event) {
			event.preventDefault();
			var temp = document.getElementById("short-l-copy");
			temp.select();
			document.execCommand("copy");
			document.querySelector(".tinyurl_copied").style.display = "block";
			setTimeout(function () {
				document.querySelector(".tinyurl_copied").style.display = "none";
			}, 1500);
		});
	}
	//  END SHORT LINK

	//SPLIDE
	if (document.getElementById('splide_attach_gallery')) {
		new Splide('#splide_attach_gallery', {
			rewind: true,
			interval: 2000,
			direction: 'rtl',
			loop: 'true',
			autoplay: true,
		}).mount();
	}


	// TABLE
	if (document.getElementById("news_article_content")) {
		var tables = document.querySelectorAll("#news_article_content table");
		tables.forEach(function (table) {
		var parentTable = document.createElement("div");
		parentTable.classList.add("table_res");
		document.querySelector("#news_article_content").replaceChild(parentTable, table);
		parentTable.appendChild(table);
		});
	}
	// END TABLE
	const direction = document.documentElement.getAttribute("dir");

	// theme changer
	const themeSwitcher = document.querySelector(".theme-switcher");

	function getTheme() {
		const localTheme = localStorage.theme;

		if (localTheme === "dark") {
			document.documentElement.classList.add("dark");
		} else if (localTheme === "light") {
			document.documentElement.classList.remove("dark");
		} else {
			if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
				document.documentElement.classList.add("dark");
			} else {
				document.documentElement.classList.remove("dark");
			}
		}
	}

	function setTheme2(e) {
		var elem = e.target;

		if (elem.classList.contains("theme-switcher-dark")) {
			localStorage.theme = "dark";
		} else if (elem.classList.contains("theme-switcher-light")) {
			localStorage.theme = "light";
		} else {
			localStorage.removeItem("theme");
		}
	}

	themeSwitcher.addEventListener("click", function (e) {
		setTheme2(e);
		getTheme();
	});

	window
		.matchMedia("(prefers-color-scheme: dark)")
		.addEventListener("change", function (e) {
			getTheme();
		});

	window.addEventListener("load", function () {
		getTheme();
	});


// desktop

	const themeSwitcher2 = document.querySelector(".theme-switcher2");

	function getTheme() {
		const localTheme2 = localStorage.theme;

		if (localTheme2 === "dark") {
			document.documentElement.classList.add("dark");
		} else if (localTheme2 === "light") {
			document.documentElement.classList.remove("dark");
		} else {
			if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
				document.documentElement.classList.add("dark");
			} else {
				document.documentElement.classList.remove("dark");
			}
		}
	}

	function setTheme(e) {
		var elem2 = e.target;

		if (elem2.classList.contains("theme-switcher2-dark")) {
			localStorage.theme = "dark";
		} else if (elem2.classList.contains("theme-switcher2-light")) {
			localStorage.theme = "light";
		} else {
			localStorage.removeItem("theme");
		}
	}

	themeSwitcher2.addEventListener("click", function (e) {
		setTheme(e);
		getTheme();
	});

	window
		.matchMedia("(prefers-color-scheme: dark)")
		.addEventListener("change", function (e) {
			getTheme();
		});

	window.addEventListener("load", function () {
		getTheme();
	});

	//header scroll behavior



	// sliders

	if (document.getElementById("sliderD")) {
		var splide = new Splide("#sliderD", {
			type: "slide",
			perPage: 4,
			autoplay: false,
			interval: 5000,
			pauseOnHover: false,
			pauseOnFocus: false,
			resetProgress: false,
			pagination: false,
			direction: direction,
			gap: "1rem",
			breakpoints: {
				768: {
					perPage: 1,
				},
				1024: {
					perPage: 2,
				},
				1280: {
					perPage: 3,
				},
			},
		});
		splide.mount();
	}

	if (document.getElementById("sliderF")) {
		var splide = new Splide("#sliderF", {
			type: "slide",
			perPage: 4,
			autoplay: false,
			interval: 5000,
			pauseOnHover: false,
			pauseOnFocus: false,
			resetProgress: false,
			pagination: false,
			direction: direction,
			gap: "1rem",
			breakpoints: {
				768: {
					perPage: 1,
				},
				1024: {
					perPage: 2,
				},
				1280: {
					perPage: 3,
				},
			},
		});
		splide.mount();
	}

	if (document.getElementById("sliderI")) {
		var splide = new Splide("#sliderI", {
			type: "loop",
			perPage: 4.5,
			autoplay: false,
			interval: 5000,
			pauseOnHover: false,
			pauseOnFocus: false,
			resetProgress: false,
			pagination: false,
			arrows: false,
			focus: "center",
			direction: direction,
			breakpoints: {
				768: {
					perPage: 1.5,
				},
				1024: {
					perPage: 2.5,
				},
				1280: {
					perPage: 3.5,
				},
			},
		});
		splide.mount();
	}

	if (document.getElementById("sliderJ")) {
		var splide = new Splide("#sliderJ", {
			type: "slide",
			perPage: 3,
			autoplay: false,
			interval: 5000,
			pauseOnHover: false,
			pauseOnFocus: false,
			resetProgress: false,
			pagination: false,
			direction: direction,
			gap: "3rem",
			breakpoints: {
				768: {
					perPage: 1,
				},
				1024: {
					perPage: 2,
				},
			},
		});
		splide.mount();
	}

	if (document.getElementById("sliderLB")) {
		var splide = new Splide("#sliderLB", {
			autoplay: true,
			interval: 5000,
			pauseOnHover: true,
			pagination: false,
			arrows: false,
			direction: direction,
			gap: "1rem",
		});

		var thumbnails = document.getElementsByClassName("thumbnail");
		var current;

		for (var i = 0; i < thumbnails.length; i++) {
			initThumbnail(thumbnails[i], i);
		}

		function initThumbnail(thumbnail, index) {
			thumbnail.addEventListener("click", function () {
				splide.go(index);
			});
		}

		splide.on("mounted move", function () {
			var thumbnail = thumbnails[splide.index];

			if (thumbnail) {
				if (current) {
					current.classList.remove("!border-white");
				}

				thumbnail.classList.add("!border-white");
				current = thumbnail;
			}
		});

		splide.mount();
	}

	// news page splide js

	var splides = document.querySelectorAll(".news .splide");
	if (splides.length) {
		for (var i = 0; i < splides.length; i++) {
			var splideElement = splides[i];
			var splideDefaultOptions = {
				type: "loop",
				direction: "rtl",
				perPage: 1,
			};

			var splide = new Splide(splideElement, splideDefaultOptions);
			splide.mount();
		}
	}

	// ---- START OF COMMENT NEWS AJAX ----
	if (document.getElementById('comment_list_ajax')) {
	const commentList = document.getElementById('comment_list_ajax');
	const loadMoreBtn = document.getElementById('load_more_comment');
	let currentPage = 1;
	// Initialize limit comment number
	const limitPage = 5;

	if (news_comment < limitPage) loadMoreBtn.remove();

	const loadMoreComments = () => {
		fetch(`/comments/ajaxCommentList?newsId=${news_id}&page=${currentPage}&limit=${limitPage}`)
		.then(response => response.json())
		.then(data => {
			if (!data || data.length < limitPage) loadMoreBtn.style.display = 'none';
			if (data) {
			data.forEach(comment => {
			const renderChildren = children => children ? `<ul>${children.map(child => `
				<li class="w-full noprint">
					<div class="text-white leading-8 transition p-4 md:p-6 lg:p-8 rounded-xl shadow-sm  lg:space-x-4 rtl:lg:space-x-reverse w-full bg-[#ffffff4f] border border_color_comment">
					<div class="w-full">
						<div class="flex items-center space-x-2 rtl:space-x-reverse w-full">
							<div class="flex space-x-2 items-center">
								<span class="font-bold text-sm lg:text-base text-[#BEBEBE] dark:text-black">${child.name || window.i18n.commentUnknown}</span>
							</div>
							<span class="text-black text-xs sm:text-sm font-semibold flex-1 dark:text-black"><time class="text-black dark:text-black"" datetime="${child.creation}">${child.date}</time></span>
							<div class="hidden ">
								<div class="flex items-center space-x-4 rtl:space-x-reverse cursor-pointer">
									<div class="flex items-center space-x-1 rtl:space-x-reverse">
										<span class="text-white dark:text-black font-semibold text-sm" aria-label="replay" onclick="setCommentParentId(${child.id})">${window.i18n.commentReply}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="mt-4 text-sm sm:text-base text-[#ADADAD] dark:text-black font-normal tracking-wide">
							<p>${child.message}</p>
						</div>
					</div>
					<div class="mt-4 flex hidden space-x-4 rtl:space-x-reverse justify-between items-center">
						<div class="flex items-center space-x-4 rtl:space-x-reverse cursor-pointer">
							<div class="flex items-center space-x-1 rtl:space-x-reverse">
								<span class="text-white dark:text-black font-semibold text-sm" aria-label="replay" onclick="setCommentParentId(${child.id})">${window.i18n.commentReply}</span>
							</div>
						</div>
					</div>
				</div>
				</li>`).join('')}</ul>` : '';

				
			commentList.innerHTML += `
				<li class="w-full noprint">
				<div class="text-white leading-8 transition p-4 md:p-6 lg:p-8 rounded-xl shadow-sm  lg:space-x-4 rtl:lg:space-x-reverse w-full bg-[#ffffff4f] border border_color_comment">		
					
					<div class="w-full">
						<div class="flex items-center space-x-2 rtl:space-x-reverse w-full">
							<div class="flex space-x-2 items-center">
								<span class="font-bold text-sm lg:text-base text-[#BEBEBE] dark:text-black">${comment.name || window.i18n.commentUnknown}</span>
							</div>
							<span class="text-black text-xs sm:text-sm font-semibold flex-1"><time class="text-black dark:text-black"" datetime="${comment.creation}">${comment.date}</time></span>
							<div class="hidden lg:block">
								<div class="flex items-center space-x-4 rtl:space-x-reverse cursor-pointer">
									<div class="flex items-center space-x-1 rtl:space-x-reverse">
										<span class="text-white dark:text-black font-semibold text-sm" aria-label="replay" onclick="setCommentParentId(${comment.id})">${window.i18n.commentReply}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="mt-4 text-sm sm:text-base text-[#ADADAD] dark:text-black font-normal tracking-wide">
							<p>${comment.message}</p>
						</div>
					</div>
					<div class="mt-4 flex lg:hidden space-x-4 rtl:space-x-reverse justify-between items-center">
						
						<div class="flex items-center space-x-4 rtl:space-x-reverse cursor-pointer">
							<div class="flex items-center space-x-1 rtl:space-x-reverse">
								<span class="text-white dark:text-black font-semibold text-sm" aria-label="replay" onclick="setCommentParentId(${comment.id})">${window.i18n.commentReply}</span>
							</div>
						</div>
					</div>
					<div class="space-y-4 mt-5 rounded reply_comment">
						${comment.children === null || comment.children.length === 0 ? '' : renderChildren(comment.children)}
					</div>
				</div>
			</li>
				`;
			});
			currentPage++;
			}
		})
		.catch(error => console.error(error));
	};

	loadMoreComments();
	loadMoreBtn.addEventListener('click', loadMoreComments);
	}



	// START OF inline ADV
	if(document.body.classList.contains('news')){
		const contentDiv = document.getElementById('news_article_content');
		const advI1 = document.getElementById('inline-adv-i1');
		const advI2 = document.getElementById('inline-adv-i2');
		
		const elements = contentDiv.querySelectorAll('p, div, table, video, img, blockquote, ol, ul');
	
		if (elements.length > 2) {
		  if(advI1){
			elements[1].insertAdjacentElement('afterend', advI1);
		  }
		}
		if (elements.length > 4) {
		  if(advI2){
			elements[3].insertAdjacentElement('afterend', advI2);
		  }
		}
	}
	// END OF inline ADV

	//  START OF style feeds/all 
	if (window.location.pathname === "/feeds/all") {
		document.body.classList.add("feeds");
	}
	//  END OF style feeds/all

});

